// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1jXzl","footer":"ModalFilter_footer__1J56S"};